import "./src/styles/global.css"
import React from "react"
import I18nWrapper from "./src/i18n/I18nWrapper"

// Wrap the app with I18nWrapper to enable translations
export const wrapRootElement = ({ element }) => {
  return <I18nWrapper>{element}</I18nWrapper>
}
